import React, { useEffect, useState } from 'react';
import { useUpdatePasswordMutation } from '../../redux/api/userApi';
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import UserLayout from '../layout/UserLayout';


const UpdatePassword = () => {

    const [oldPassword, setOldPassword] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate();

    const [UpdatePassword, { isLoading, error, isSuccess }] = useUpdatePasswordMutation();


    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            toast.success("Password Updated");
            navigate("/me/profile");
        }
    }, [error, isSuccess, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();

        const userData = {
            oldPassword,
            password,
        };

        UpdatePassword(userData);
    };
    return (
        <UserLayout>
            <div className="row wrapper mt-0 pt-0">
                <div className="col-12 col-lg-8">
                    <form className="product-card shadow-sm rounded-4 bg-body" onSubmit={submitHandler}>
                        <h2 className="mb-4 fw-bold text-gradient">Update Password</h2>
                        <div className="mb-3">
                            <label htmlFor="old_password_field" className="form-label" style={{ color: "#e04f6ecd" }}>
                                Old Password
                            </label>
                            <input
                                type="password"
                                id="old_password_field"
                                className="form-control"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="new_password_field" className="form-label" style={{ color: "#e04f6ecd" }}>
                                New Password
                            </label>
                            <input
                                type="password"
                                id="new_password_field"
                                className="form-control"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        <button type="submit" className="btn w-100 py-2 fw-semibold View-btn" disabled={isLoading}>
                            {isLoading ? "Updating..." : "Update Password"}
                        </button>
                    </form>
                </div>
            </div>
        </UserLayout>
    )
}

export default UpdatePassword
